/**
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
/** The http protocol string. */
const HTTP_PROTOCOL = 'http:';
/** The https protocol string. */
const HTTPS_PROTOCOL = 'https:';
/** The default port for the http protocol. */
const HTTP_PORT = 80;
/** The default port for the https protocol. */
const HTTPS_PORT = 443;

export { HTTPS_PORT, HTTPS_PROTOCOL, HTTP_PORT, HTTP_PROTOCOL };
